import React from "react";
import { SourcesList } from "../components/SourcesList";

export function SourcesPage({ agentId }: { agentId: string }) {
  return (
    <div className="dashboard">
      <div className="agent-detail">
        <SourcesList agentId={agentId} />
      </div>
    </div>
  );
}
